export const modalPlaces = {
	message:
		"Utilice la tabla a continuación para activar y desactivar el {{ groupOrProfile }} fiscal en su organización.",
	group: "Grupo",
	profile: "Perfil",
	title: "Locales vinculados al {{ groupOrProfile }} fiscal: {{ name }}",
	searchPlace: "Buscar local",
	placesAt: "Locales en",
};
